import ContactPage from './ContactPage.jsx';

export {
  ContactPage
}


// WEBPACK FOOTER //
// ./pages/contact/index.js